import {
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
} from "@/client/components/shad/sidebar";
import { createFileRoute } from "@tanstack/react-router";
import { PdarStatus } from "./-features/PdarStatus";

import { PdarStations } from "./-features/PdarStations";
import { ScrollArea } from "@/client/components/shad/scroll-area";
import { PdarTargets } from "./-features/PdarTargets";
import { PdarOptions } from "./-features/PdarOptions";
import { PdarView } from "./-features/PdarView";

export const Route = createFileRoute("/(protected)/map/pdar/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <SidebarHeader className=" text-sm border-b px-3 py-3">
        <PdarStatus />
      </SidebarHeader>
      <SidebarContent className="p-1 pt-0 pb-3 text-xs h-full">
        {/*<SidebarGroup>
          <div className="flex items-center space-x-2"></div>
        </SidebarGroup>*/}

        <SidebarGroup className="flex relative flex-col gap-5">
          <PdarView />
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="pb-2 border-t">
        <PdarOptions />
      </SidebarFooter>
    </>
  );
}
